import { Link } from "react-router-dom"
import Image from '../images/main_header.png'

const MainHeader = () => {
  return (
   <header className="main__header">
    <div className=".container main__header-container">
      <div className="main__header-left">
        <h4>#100DaysofWorkOut</h4>
        <h1>Join the Legends of the fitness Clubs</h1>
        <p>
          Lorem, ipsum dolor. Lorem ipsum dolor sit amet consectetur 
          eligendi esse quod qui, ducimus perferendis. Placeat?
        </p>
        <Link to='/plans' className="btn lg">Get Started</Link>
      </div>
        <div className="main__header-right">
          <div className="main__header-circle"></div>
          <div className="main__header-image">
            <img src={Image} alt="Main_Header" />
          </div>
        </div>
    </div>
   </header>
  )
}

export default MainHeader